import React, { Component } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import parseQueryParams from '../../../utils/parseQueryParams'
import API from '../../../api/auth'
import MessageConstants from '../../../constants/MessageConstants'
import ResourceConstants from '../../../constants/ResourceConstants.js'
import ChatLink from '../../shared/ChatLink'
import { Div, H1, Input, Button, Form } from '@driftt/tide-core'

const STRENGTH_ERRORS = {
  'LENGTH' : 'Your password must be between 10 - 72 characters',
  'SPECIAL_CHAR': 'Your password must have at least one special character',
  'MATCHES_USERNAME': 'Your password cannot be your name',
  'ENTROPY': 'Your password must have at least 4 unique characters',
  'MATCHES_EMAIL': 'Your password cannot be your email',
}

const ParseStrengthErrors = ({ errors }) => (
  <ul className="strength-error-list">
    {errors.map(error => <li>{STRENGTH_ERRORS[error.message]}</li>)}
  </ul>
)

class AcceptInvitation extends Component {

  constructor(props) {
    super(props)

    this.state = {
      resetToken: null,
      password: '',
      hasReset: false,
      error: '',
      name: ''
    }

    this.handlePasswordInput = this.handlePasswordInput.bind(this)
    this.handleNameInput = this.handleNameInput.bind(this)
    this.submitAccept = this.submitAccept.bind(this)
    this.handleResponse = this.handleResponse.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.redirectHome(nextProps)
  }

  componentWillMount() {
    this.redirectHome(this.props)
  }

  redirectHome(props) {
    const queryParams = parseQueryParams(props.location.search)

    if (!queryParams.token) props.history.push('/')
    else this.setState({ resetToken: queryParams.token })
  }

  handleResponse(response, name) {
    let message = MessageConstants.DEFAULT_SERVER_ERROR

    if (response.status === 403) {
      this.setState({ error: MessageConstants.EXPIRED_TOKEN_ACCEPT })
    } else if(response.status === 404) {
      this.setState({error: MessageConstants.USER_NOT_FOUND})
    } else if (response.status === 400){
      if (!!response.data.errors && response.data.errors.length) {
        message = <ParseStrengthErrors errors={response.data.errors} />
      }
      this.setState({ error: message })
    } else if (response.status === 401){
      this.setState({ error: MessageConstants.INVALID_TOKEN })
    } else if (response.status === 200) {
      const token = response.data.access_token

      API
        .fetchCurrentUser(token)
        .then(({ data }) => API.updateName(data.id, this.state.name, token))
        .then(() => window.location.replace(`${ResourceConstants.APP_ROOT}?token=${token}&justAccepted=true`))
    }
  }

  submitAccept(event) {
    event.preventDefault()
    API.acceptInvitation(this.state.password, this.state.resetToken, this.handleResponse)
  }

  handlePasswordInput(event) {
    this.setState({ password: event.target.value })
  }

  handleNameInput(event) {
    this.setState({ name: event.target.value, error: '' })
  }

  render() {
    if (this.state.hasReset) return <Redirect to={'/'} />

    return (
      <Div className="forgot-password-page">
      	<H1>Join your team at Drift</H1>
        <Form className="drift-form">
          <Input onChange={this.handleNameInput} size="large" type="text" placeholder="your name" required />
          <Input onChange={this.handlePasswordInput} minLength="10" size="large" type="password" placeholder="a password (at least 10 characters)" required />
          {this.state.error && <strong className="request-status error">{ this.state.error }</strong> }
          <Button size="large" onClick={this.submitAccept}>Join my Team</Button>
          <ChatLink />
       </Form>
      </Div>
    )
  }
}

const AcceptInvitationPage = withRouter(AcceptInvitation)
export default AcceptInvitationPage



// WEBPACK FOOTER //
// ./src/components/pages/AcceptInvitation/index.js